module.exports = __webpack_public_path__ + "img/plus-dark-green.c62c46c3.svg";